// Some of these are unique to the FE, see RecordFilterType for BE filter types
const AddDataSourceFilterRecordsByTypes = {
  ASSOCIATION_LABEL: 'ASSOCIATION_LABEL',
  MATCHING_PROPERTY: 'MATCHING_PROPERTY',
  PROPERTY_VALUE: 'PROPERTY_VALUE'
};
export default AddDataSourceFilterRecordsByTypes;